import React from 'react';
import './Toggle.css';

interface ToggleProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  onLabel?: string;
  offLabel?: string;
}

/**
 * Toggle switch component
 */
export function Toggle({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  onLabel = 'On',
  offLabel = 'Off',
}: ToggleProps) {
  return (
    <div className={`toggle-field ${className}`}>
      <label htmlFor={id} className="toggle-label">
        {label}
      </label>
      <button
        type="button"
        id={id}
        role="switch"
        aria-checked={checked}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`toggle-switch ${checked ? 'checked' : ''}`}
      >
        <span className="toggle-slider" />
        <span className="toggle-text">{checked ? onLabel : offLabel}</span>
      </button>
    </div>
  );
}

export default Toggle;
